import React from "react";
import { Flex } from "@UI/Components/Flex/Flex";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Text } from "@UI/Components/Text/Text";
import messages from "../messages";
import { Link } from "@UI/Components/Link/Link";

export const OppositionLink = ({ url }: { url: string }) => {
  return (
    <Flex mt={4} justifyContent="center" flexWrap="wrap">
      <FormattedMessage {...messages.noAgreement} />
      <Link as="a" href={url}>
        <Text textDecoration="underline" cursor="pointer" ml={1}>
          <FormattedMessage {...messages.opposePayment} />
        </Text>
      </Link>
    </Flex>
  );
};
